import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initFeature() {
    const mediaContainers = document.querySelectorAll('.feature__media, .feature__left .img, .feature__right .img');

    mediaContainers.forEach(container => {
        const media = container.querySelector('img, video');
        if (!media) return;

        // Save inline transition and temporarily disable it to avoid conflicting with GSAP
        const originalTransition = media.style.transition;
        media.style.transition = 'none';

        // Scale up slightly so we have extra image to translate vertically without seeing behind it
        gsap.set(media, {
            scale: 1.15,
            yPercent: -10, // Start higher up
            transformOrigin: "center center"
        });

        // Force flush to ensure the initial scale applies without transition
        media.getBoundingClientRect();

        gsap.to(media, {
            yPercent: 10,   // Scrub down
            ease: 'none',
            scrollTrigger: {
                trigger: container,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });

    });

    // Pause/Play logic — the video + button live in .feature__small, which is
    // animated separately below, so wire these up independently of the parallax loop.
    document.querySelectorAll('.feature__pause').forEach(pauseBtn => {
        const video = pauseBtn.closest('.feature__small, .feature__media')?.querySelector('video');
        if (!video) return;

        pauseBtn.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                pauseBtn.classList.remove('is-paused');
                pauseBtn.setAttribute('aria-label', 'Pause video');
                pauseBtn.setAttribute('title', 'Pause video');
            } else {
                video.pause();
                pauseBtn.classList.add('is-paused');
                pauseBtn.setAttribute('aria-label', 'Play video');
                pauseBtn.setAttribute('title', 'Play video');
            }
        });
    });

    // Scroll-driven position animation for .feature__small
    const mm = gsap.matchMedia();
    mm.add('(min-width: 992px)', () => {
        document.querySelectorAll('.feature__small').forEach(container => {
            const section = container.closest('.feature');
            if (!section) return;

            gsap.to(container,
                {
                    y: () => {
                        const parentH = container.offsetParent.offsetHeight;
                        return parentH * 0.76 - container.offsetHeight;
                    },
                    ease: 'power1.inOut',
                    scrollTrigger: {
                        trigger: section,
                        start: 'top center',
                        end: 'bottom center',
                        scrub: true,
                        invalidateOnRefresh: true,
                    }
                }
            );
        });
    });
}
